"use client";

import React from 'react';
import Link from 'next/link';
import { ArrowLeft, Star, Crown, Eye, Sun, Moon, Zap } from 'lucide-react';
import { AboutLayout } from '@/components/about/about-layout';

export default function MarseilleMarjorArcanaPage() {
  const majorArcanaCards = [
    { number: "I", name: "Le Bateleur", enName: "The Magician", description: "Beceri ve yaratıcılık", path: "le-bateleur" },
    { number: "II", name: "La Papesse", enName: "The High Priestess", description: "Bilgi ve sezgi", path: "la-papesse" },
    { number: "III", name: "L'Impératrice", enName: "The Empress", description: "Bereket ve yaratıcılık", path: "l-imperatrice" },
    { number: "IV", name: "L'Empereur", enName: "The Emperor", description: "Otorite ve düzen", path: "l-empereur" },
    { number: "V", name: "Le Pape", enName: "The Hierophant", description: "Öğretim ve gelenek", path: "le-pape" },
    { number: "VI", name: "L'Amoureux", enName: "The Lovers", description: "Seçim ve aşk", path: "l-amoureux" },
    { number: "VII", name: "Le Chariot", enName: "The Chariot", description: "Zafer ve kontrol", path: "le-chariot" },
    { number: "VIII", name: "La Justice", enName: "Justice", description: "Adalet ve denge", path: "la-justice" },
    { number: "IX", name: "L'Ermite", enName: "The Hermit", description: "İç arayış ve bilgelik", path: "l-ermite" },
    { number: "X", name: "La Roue de Fortune", enName: "Wheel of Fortune", description: "Döngüler ve kader", path: "la-roue-de-fortune" },
    { number: "XI", name: "La Force", enName: "Strength", description: "İç güç ve sabır", path: "la-force" },
    { number: "XII", name: "Le Pendu", enName: "The Hanged Man", description: "Fedakarlık ve bakış açısı", path: "le-pendu" },
    { number: "XIII", name: "L'Arcane sans nom", enName: "Death", description: "Dönüşüm ve yeniden doğuş", path: "l-arcane-sans-nom" },
    { number: "XIV", name: "Tempérance", enName: "Temperance", description: "Denge ve uyum", path: "temperance" },
    { number: "XV", name: "Le Diable", enName: "The Devil", description: "Tutku ve kısıtlamalar", path: "le-diable" },
    { number: "XVI", name: "La Maison Dieu", enName: "The Tower", description: "Ani değişim ve aydınlanma", path: "la-maison-dieu" },
    { number: "XVII", name: "L'Étoile", enName: "The Star", description: "Umut ve ilham", path: "l-etoile" },
    { number: "XVIII", name: "La Lune", enName: "The Moon", description: "İllüzyon ve bilinçsiz", path: "la-lune" },
    { number: "XIX", name: "Le Soleil", enName: "The Sun", description: "Başarı ve canlılık", path: "le-soleil" },
    { number: "XX", name: "Le Jugement", enName: "Judgement", description: "Yeniden doğuş ve karar", path: "le-jugement" },
    { number: "XXI", name: "Le Monde", enName: "The World", description: "Tamamlanma ve birlik", path: "le-monde" },
    { number: "0", name: "Le Mat", enName: "The Fool", description: "Yeni başlangıçlar", path: "le-mat" }
  ];

  return (
    <AboutLayout activeSection="tarot">
      <div className="max-w-6xl mx-auto px-4 py-8">
        {/* Current Section Indicator */}
        <div className="mb-4 p-3 bg-red-500/10 border border-red-500/20 rounded-lg">
          <div className="flex items-center gap-2 text-red-300">
            <Star className="h-4 w-4" />
            <span className="text-sm font-medium">🃏 Tarot</span>
            <span className="text-red-500">/</span>
            <span className="text-sm">Marseille</span>
            <span className="text-red-500">/</span>
            <span className="text-sm">Majör Arkana</span>
          </div>
        </div>

        {/* Breadcrumb */}
        <div className="mb-6">
          <Link
            href="/about"
            className="inline-flex items-center text-slate-400 hover:text-slate-200 transition-colors"
          >
            <ArrowLeft className="h-4 w-4 mr-2" />
            AXTROLOG Nedir
          </Link>
          <span className="text-slate-500 mx-2">/</span>
          <Link
            href="/about/tarot/systems"
            className="text-slate-400 hover:text-slate-200 transition-colors"
          >
            Tarot Sistemleri
          </Link>
          <span className="text-slate-500 mx-2">/</span>
          <Link
            href="/about/tarot/systems/marseille"
            className="text-slate-400 hover:text-slate-200 transition-colors"
          >
            Tarot de Marseille
          </Link>
          <span className="text-slate-500 mx-2">/</span>
          <span className="text-slate-300">Majör Arkana</span>
        </div>

        {/* Header */}
        <div className="bg-gradient-to-r from-red-900/20 to-orange-900/20 rounded-xl p-8 mb-8 border border-red-500/20">
          <h1 className="text-4xl font-bold text-slate-100 mb-4 flex items-center gap-3">
            <Star className="h-10 w-10 text-red-400" />
            Marseille Majör Arkana
          </h1>
          <p className="text-lg text-slate-200 leading-relaxed">
            22 trump kartından oluşan Majör Arkana, yaşamın büyük dönüşüm aşamalarını ve ruhsal yolculuğu temsil eder.
            Geleneksel Avrupa tarot geleneğinin özünü barındıran bu kartlar, sade ama güçlü sembolizm kullanır.
          </p>
        </div>

        {/* Marseille vs RWS Differences */}
        <div className="mb-8">
          <h2 className="text-2xl font-semibold text-slate-100 mb-6">Marseille ve RWS Farklılıkları</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="bg-slate-800 rounded-xl p-6 border border-slate-700">
              <h3 className="text-lg font-semibold text-slate-100 mb-3 flex items-center gap-2">
                <Crown className="h-5 w-5 text-red-400" />
                Marseille Geleneği
              </h3>
              <ul className="space-y-2 text-slate-300 text-sm">
                <li>• Geleneksel sıralama: Justice (VIII), Strength (XI)</li>
                <li>• "L'Arcane sans nom" - Death kartı isimsiz</li>
                <li>• Sade, geometrik sembolizm</li>
                <li>• Fransızca/Latince başlıklar</li>
                <li>• Minimal renk paleti</li>
              </ul>
            </div>
            <div className="bg-slate-800 rounded-xl p-6 border border-slate-700">
              <h3 className="text-lg font-semibold text-slate-100 mb-3 flex items-center gap-2">
                <Eye className="h-5 w-5 text-yellow-400" />
                Okuma Yaklaşımı
              </h3>
              <ul className="space-y-2 text-slate-300 text-sm">
                <li>• Sezgisel yorumlama ön planda</li>
                <li>• Sembolik açıdan daha açık</li>
                <li>• Okuyucunun deneyimi kritik</li>
                <li>• Geleneksel anlamlar korunmuş</li>
                <li>• Numerolojik bağlantılar güçlü</li>
              </ul>
            </div>
          </div>
        </div>

        {/* Cards Grid */}
        <div className="mb-8">
          <h2 className="text-2xl font-semibold text-slate-100 mb-6">22 Majör Arkana Kartı</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
            {majorArcanaCards.map((card, index) => (
              <Link
                key={index}
                href={`/about/tarot/systems/marseille/major-arcana/${card.path}`}
                className="group bg-slate-800 rounded-xl p-4 border border-slate-700 hover:border-red-500/50 transition-all duration-300 hover:shadow-lg hover:shadow-red-500/10"
              >
                <div className="flex flex-col items-center text-center">
                  <div className="w-20 h-32 mb-3 rounded-lg overflow-hidden bg-gradient-to-b from-red-900/20 to-slate-900 border border-red-600/20 group-hover:scale-105 transition-transform duration-300">
                    <div className="w-full h-full flex items-center justify-center">
                      <img
                        src={`/images/tarot/cards/marseille-${card.path}.svg`}
                        alt={card.name}
                        className="w-full h-full object-cover"
                        onError={(e) => {
                          const target = e.currentTarget;
                          target.style.display = 'none';
                          if (target.nextElementSibling) {
                            (target.nextElementSibling as HTMLElement).style.display = 'flex';
                          }
                        }}
                      />
                      <div className="hidden w-full h-full flex-col items-center justify-center text-red-300">
                        <span className="text-lg font-bold">{card.number}</span>
                        <span className="text-xs">{card.name}</span>
                      </div>
                    </div>
                  </div>
                  <div className="mb-2">
                    <div className="text-lg font-semibold text-slate-100 mb-1">{card.name}</div>
                    <div className="text-sm text-red-400 mb-1">({card.number}) {card.enName}</div>
                    <div className="text-xs text-slate-400">{card.description}</div>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>

        {/* Reading Techniques */}
        <div className="mb-8">
          <h2 className="text-2xl font-semibold text-slate-100 mb-6">Marseille Okuma Teknikleri</h2>
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
            <div className="bg-slate-800 rounded-xl p-6 border border-slate-700">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 bg-gradient-to-br from-blue-500 to-blue-700 rounded-lg flex items-center justify-center">
                  <Eye className="h-5 w-5 text-white" />
                </div>
                <h3 className="text-lg font-semibold text-slate-100">Görsel Okuma</h3>
              </div>
              <p className="text-slate-300 text-sm">
                Marseille kartlarında sadece önemli detayları görsel olarak analiz edin.
                Fazla detay yok, her element bilinçli seçilmiş.
              </p>
            </div>

            <div className="bg-slate-800 rounded-xl p-6 border border-slate-700">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 bg-gradient-to-br from-purple-500 to-purple-700 rounded-lg flex items-center justify-center">
                  <Zap className="h-5 w-5 text-white" />
                </div>
                <h3 className="text-lg font-semibold text-slate-100">Numerolojik</h3>
              </div>
              <p className="text-slate-300 text-sm">
                Kart numaralarının anlamlarına odaklanın. Marseille geleneğinde
                sayısal değerler çok önemli yorumlama anahtarlarıdır.
              </p>
            </div>

            <div className="bg-slate-800 rounded-xl p-6 border border-slate-700">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 bg-gradient-to-br from-green-500 to-green-700 rounded-lg flex items-center justify-center">
                  <Moon className="h-5 w-5 text-white" />
                </div>
                <h3 className="text-lg font-semibold text-slate-100">Sezgisel</h3>
              </div>
              <p className="text-slate-300 text-sm">
                Kartlardaki az detay, okuyucunun sezgisine daha fazla alan bırakır.
                İç sesini dinlemek kritik önem taşır.
              </p>
            </div>
          </div>
        </div>

        {/* Historical Context */}
        <div className="mb-8">
          <h2 className="text-2xl font-semibold text-slate-100 mb-6">Tarihsel Bağlam</h2>
          <div className="bg-slate-800 rounded-xl p-6 border border-slate-700">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <h3 className="text-lg font-semibold text-slate-100 mb-3">Geleneksel Sıralama</h3>
                <p className="text-slate-300 text-sm mb-3">
                  Marseille tarot, Waite'in değiştirdiği sıralamayı korur:
                </p>
                <div className="space-y-1 text-xs text-slate-400">
                  <div>• VIII - La Justice (Adalet)</div>
                  <div>• XI - La Force (Güç)</div>
                  <div>• Bu sıralama astrolojik bağlantıları korur</div>
                </div>
              </div>
              <div>
                <h3 className="text-lg font-semibold text-slate-100 mb-3">Özel Kartlar</h3>
                <p className="text-slate-300 text-sm mb-3">
                  Bazı kartlar Marseille geleneğinde özeldir:
                </p>
                <div className="space-y-1 text-xs text-slate-400">
                  <div>• XIII - L'Arcane sans nom (İsimsiz Arkana)</div>
                  <div>• Le Mat - Sayısız kart (bazen 0, bazen sayısız)</div>
                  <div>• XVI - La Maison Dieu (Tanrı'nın Evi)</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Important Note */}
        <div className="bg-amber-900/20 border border-amber-700/50 rounded-xl p-6 mb-8">
          <h3 className="text-lg font-semibold text-amber-200 mb-3">⚠️ Önemli Uyarı</h3>
          <p className="text-amber-100 leading-relaxed">
            Bu kart anlamları geleneksel Marseille tarot yorumlarına dayanmaktadır ve sadece eğlence ve kişisel farkındalık amaçlıdır.
            Yaşamsal kararlar için uzman görüşü alınmalıdır.
          </p>
        </div>

        {/* Navigation */}
        <div className="flex justify-between items-center">
          <Link
            href="/about/tarot/systems/marseille"
            className="inline-flex items-center px-4 py-2 bg-slate-800 hover:bg-slate-700 border border-slate-600 rounded-lg text-slate-300 hover:text-slate-100 transition-colors"
          >
            <ArrowLeft className="h-4 w-4 mr-2" />
            Tarot de Marseille
          </Link>

          <Link
            href="/about/tarot/systems/marseille/minor-arcana"
            className="inline-flex items-center px-4 py-2 bg-red-600 hover:bg-red-700 text-white rounded-lg transition-colors"
          >
            Minör Arkana
            <ArrowLeft className="h-4 w-4 ml-2 rotate-180" />
          </Link>
        </div>
      </div>
    </AboutLayout>
  );
}